import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Back to login")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_result = _resolveComponent("a-result")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_a_result, {
      status: "404",
      title: "404",
      "sub-title": "Sorry, the page you visited does not exist."
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.backHome()), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}